import React from 'react';

import Icon from '../Icon/Icon';

const IlumaDisconnectedIcon = (props) => {
    return (
        <Icon width='48' height='48' fill='none' {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.25 41.25C13.549 41.25 12.799 40.0982 12 37.7947V12.0345C12 10.9593 12.4475 9.94784 13.3425 9H18.1575C19.0525 9.94784 19.5 10.9593 19.5 12.0345V37.7947C18.701 40.0982 17.951 41.25 17.25 41.25H14.25Z'
                stroke='#34303D'
                strokeWidth='2.5'
                strokeLinejoin='round'
            />
            <path
                d='M15.8149 25.0351C16.5848 25.0351 17.2089 24.411 17.2089 23.6411C17.2089 22.8712 16.5848 22.2471 15.8149 22.2471C15.045 22.2471 14.4209 22.8712 14.4209 23.6411C14.4209 24.411 15.045 25.0351 15.8149 25.0351Z'
                fill='#34303D'
                stroke='#00D1D2'
                strokeWidth='1.5'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M29.25 6.9375C30.8551 6.9375 32.3082 7.58809 33.3601 8.63994C34.4119 9.6918 35.0625 11.1449 35.0625 12.75V39.75C35.0625 40.1124 34.9156 40.4406 34.6781 40.6781C34.4406 40.9156 34.1124 41.0625 33.75 41.0625H24.75C24.3876 41.0625 24.0594 40.9156 23.8219 40.6781C23.5844 40.4406 23.4375 40.1124 23.4375 39.75V8.25C23.4375 7.88756 23.5844 7.55944 23.8219 7.32192C24.0594 7.08441 24.3876 6.9375 24.75 6.9375H29.25Z'
                stroke='#34303D'
                strokeWidth='2.5'
            />
            <rect
                x='7.58579'
                y='10'
                width='4'
                height='43'
                rx='2'
                transform='rotate(-45 7.58579 10)'
                fill='#34303D'
                stroke='#FFFDFB'
                strokeWidth='2'
            />
        </Icon>
    );
};

export default IlumaDisconnectedIcon;
